import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import { useAdminAuthStore } from '../../store/adminAuthStore';

const AdminForbiddenPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAdminAuthStore();

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-4">
      <ShieldOff size={48} className="text-[var(--color-gray-400)] mb-4" />
      <h1 className="text-xl font-semibold text-[var(--color-gray-800)] mb-2">No admin access</h1>
      <p className="text-sm text-[var(--color-gray-600)] max-w-md mb-6">
        Your account is signed in but has no permissions for the Admin Console. Contact a system
        administrator to assign a role with the required access.
      </p>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="secondary"
          onClick={() => {
            logout();
            navigate('/admin/login', { replace: true });
          }}
        >
          Sign out
        </Button>
      </div>
    </div>
  );
};

export default AdminForbiddenPage;
